import React from 'react';
import MainStake from '../components/mainstake/MainStake';
import NavbarThree from "../components/navbarthree/NavbarThree"

function Main() {
    return (
        <div>
            <NavbarThree/>
           <MainStake/>
        </div>
    )
}

export default Main;
